module.exports = __webpack_public_path__ + "static/media/banner_mobil.fd18b0bb.png";